import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const purchases = [['Sarah M.', 'Austin, USA 🇺🇸', '5 MIN AGO'], ['Ella B.', 'Bristol, UK 🇬🇧', '8 MIN AGO'], ['Ada O.', 'Lagos, Nigeria 🇳🇬', '12 MIN AGO'], ['Maya K.', 'Toronto, Canada 🇨🇦', '16 MIN AGO']];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  useEffect(() => {
    const showTimer = window.setTimeout(() => setIsVisible(true), 4000);
    const cycleTimer = window.setInterval(() => {
      setPurchaseIndex(current => (current + 1) % purchases.length);
    }, 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(cycleTimer);
    };
  }, []);
  const [name, location, time] = purchases[purchaseIndex];
  return <AnimatePresence data-id="element-336">
      {isVisible && <motion.aside role="status" initial={{
      opacity: 0,
      x: -20,
      y: 42
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.94
    }} className="fixed bottom-5 left-4 z-50 flex max-w-[calc(100vw-2rem)] items-start gap-3 rounded-2xl border border-brand-dark bg-brand-alt p-4 pr-10 shadow-xl sm:bottom-6 sm:left-6 sm:max-w-sm" data-id="element-337">
          <button type="button" aria-label="Dismiss notification" onClick={() => setIsVisible(false)} className="absolute right-3 top-3 text-brand-gray transition-colors hover:text-brand-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red" data-id="element-338">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-339" />
          </button>
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-dark text-lg" aria-hidden="true" data-id="element-340">
            🎨
          </div>
          <AnimatePresence mode="wait" data-id="element-341">
            <motion.div key={name} initial={{
          opacity: 0,
          y: 5
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -5
        }} transition={{
          duration: 0.2
        }} data-id="element-342">
              <p className="text-sm font-bold" data-id="element-343">
                {name} — {location}
              </p>
              <p className="mt-0.5 text-xs font-extrabold text-brand-red" data-id="element-344">
                Just purchased ART READY
              </p>
              <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold tracking-wide text-brand-gray" data-id="element-345">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand-red" data-id="element-346" />
                VERIFIED PURCHASE · {time}
              </p>
            </motion.div>
          </AnimatePresence>
        </motion.aside>}
    </AnimatePresence>;
}